 <template>
  <v-form ref="pto_form" lazy-validation>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          class="ml-3"
          small
          tile
          depressed
          color="blue"
        >
          <v-icon left> mdi-playlist-check </v-icon>
          View / Confirm
        </v-btn>
      </template>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark class="ptoClose" @click="closeConfirmDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>View and Confirm Dates Taken</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="submitPtoConfirm" class="dk_brown"> Save </v-btn>
          </v-toolbar-items>
        </v-toolbar>

       <v-container class="ml-5 mt-0 mb-0 pt-0 pb-0">
          <v-row>
            <v-col cols="12" class="note">
              Bereavement, Jury Duty and COVID Vaccine/Booster dates are not included. 
              <!-- br>
              If you took leave that is not reflected please select Incorrect, provide Incorrect Reason and Save. Then please revisit the leave request page and retroactively submit your leave. -->
            </v-col>
          </v-row>
       </v-container>        

        <!-- No Dates Taken -->
        <v-container class="ml-10 mt-0 mb-0 pt-0 pb-0"
          v-if="this.has_no_pto_mth == true"
        >
          <v-row v-if="no_pto_inputs.length > 0">
            <p class="inst">If you took leave that is not reflected please select Incorrect, provide Incorrect Reason and Save. Then please revisit the leave request page and retroactively submit your leave.</p>
            <v-col cols="12" class="pl-0 pt-0">
              <div v-for="(no_pto, j) in no_pto_inputs" :key="j">
                <v-row>
                  <v-col cols="3">No Dates Taken: {{ no_pto.month_name}}
                  </v-col>
                  <v-col cols="9">
                    <v-btn
                      value="yes"
                      v-bind:data="no_pto.id"
                      v-bind:id="no_pto.id + '_yes'"
                      class="subtitle-2"
                      @click="selectNoPto"
                      :sync="true"
                    >
                      Correct
                    </v-btn>
                    <v-btn
                      value="no"
                      v-bind:data="no_pto.id"
                      v-bind:id="no_pto.id + '_no'"
                      class="subtitle-2"
                      @click="selectNoPto"
                    >
                      Incorrect
                    </v-btn>
                    <br />
                  </v-col>
                </v-row>

                <div class="form-group">
                  <div
                    v-bind:id="no_pto.id"
                    style="display: none"
                  >
                    <v-row
                      :class="{
                        dateBlockMobile: $vuetify.breakpoint.xs,
                        dateBlock: $vuetify.breakpoint.smAndUp,
                      }"
                    >
                      <v-col
                        :class="{
                          custom1cols: $vuetify.breakpoint.xs,
                          custom3cols: $vuetify.breakpoint.smAndUp,
                        }"
                      >
                        <v-subheader class="pl-0 prompt">Incorrect Reason </v-subheader>
                      </v-col>
                      <v-col
                        :class="{
                          confirmCustom1cols: $vuetify.breakpoint.xs,
                          custom9cols: $vuetify.breakpoint.smAndUp,
                        }"
                      >
                        <v-text-field
                          v-model="no_pto['comment']"
                          aria-label="Incorrect Reason"
                          outlined
                          dense
                          required
                          counter
                          maxlength="200"
                          :rules="[commentRules.required, commentRules.counter]"
                          class="messages"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>

        <!-- Pending Confirmed Loop -->
        <v-container
          class="ml-10 mt-0 mb-0 pt-0 pb-0"
          v-for="(p, i) in p_cfm_pto"
          :key="i"
        >
          <v-row v-if="p.taken_info_array.length > 0">
            <v-col cols="12" class="font-weight-medium">{{
              p.name_plural
            }}</v-col>
          </v-row>
          <v-row v-if="p.taken_info_array.length > 0">
            <v-col cols="12" class="pl-0 pt-0">
              <div v-for="(taken, j) in p.taken_info_array" :key="j">
                <v-row>
                  <v-col cols="3">
                    <!--
                    <v-icon
                      class="icon-circle-gray icon-white"
                      v-if="p.taken_status_array[j] == 'Pending'"
                      aria-label="Pending Manager Approval"
                      >mdi-timer-sand</v-icon
                    ><v-icon
                      v-if="p.taken_status_array[j] == 'Approved'"
                      class="icon-circle-green"
                      aira-label="Manager Approved"
                      >mdi-check-circle</v-icon
                    > -->
                    {{ taken }}
                  </v-col>
                  <v-col cols="9">
                    <v-btn
                      value="yes"
                      v-bind:data="p.taken_ids[j]"
                      v-bind:id="p.taken_ids[j] + '_yes'"
                      v-bind:cat="i"
                      v-bind:pos="j"
                      class="subtitle-2"
                      @click="selectPtoCfm"
                      :sync="true"
                    >
                      Correct
                    </v-btn>
                    <v-btn
                      value="no"
                      v-bind:data="p.taken_ids[j]"
                      v-bind:id="p.taken_ids[j] + '_no'"
                      class="subtitle-2"
                      @click="selectPtoCfm"
                    >
                      Incorrect
                    </v-btn>
                    <br />
                  </v-col>
                </v-row>

                <div class="form-group" v-for="(input, k) in inputs" :key="k">
                  <div
                    v-if="input.taken_id == p.taken_ids[j]"
                    v-bind:id="p.taken_ids[j]"
                    style="display: none"
                  >
                    <v-row
                      :class="{
                        dateBlockMobile: $vuetify.breakpoint.xs,
                        dateBlock: $vuetify.breakpoint.smAndUp,
                      }"
                    >
                      <v-col
                        :class="{
                          custom1cols: $vuetify.breakpoint.xs,
                          custom3cols: $vuetify.breakpoint.smAndUp,
                        }"
                      >
                        <v-subheader class="pl-0 prompt">Incorrect Reason </v-subheader>
                      </v-col>
                      <v-col
                        :class="{
                          confirmCustom1cols: $vuetify.breakpoint.xs,
                          custom9cols: $vuetify.breakpoint.smAndUp,
                        }"
                      >
                        <v-text-field
                          v-model="input['comment']"
                          aria-label="Incorrect Reason"
                          outlined
                          dense
                          required
                          counter
                          maxlength="200"
                          :rules="[commentRules.required, commentRules.counter]"
                          class="messages"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>

        <div class="form_padding">&nbsp;</div>

      </v-card>
    </v-dialog>

    <div class="text-center">
      <v-dialog
        v-model="dialog2"
        persistent
        max-width="350"
        :retain-focus="false"
      >
        <v-card>
          <v-card-title class="headline">
            {{ dialog2_title }}
          </v-card-title>
          <v-card-text>{{ dialog2_text }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-if="dialog2_redBtn != ''"
              color="red darken-1"
              text
              @click="closeDialog(dialog2_redBtn_type)"
            >
              {{ dialog2_redBtn }}
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="closeDialog(dialog2_blueBtn_type)"
            >
              {{ dialog2_blueBtn }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-form>
</template>
      
<script>
import pto_func from "@/pto_functions";
import axios from "axios";

export default {
  props: ["pto", "ptoInfo"],

  data() {
    return {
      dialog: false,
      dialog2: false,
      dialog2_title: "Alert!",
      dialog2_blueBtn: "OK",
      dialog2_blueBtn_type: "",
      dialog2_text: "",
      dialog2_redBtn: "",
      dialog2_redBtn_type: "",

      pto_cat_codes: [],
      toggle_exclusive: [],
      toggle_states: [],
      has_pending_pto: false,
      has_no_pto_mth: false,

      inputs: [],
      no_pto_inputs: [],

      cfm_pto: null,
      cur_fiscal_year: pto_func.get_fiscal_year("cur_long"),
      prev_fiscal_year: pto_func.get_fiscal_year("prev_long"),
      site_status: pto_func.get_site_status(), 

      p_cfm_pto: {
        vacation: {
          name: "",
          name_plural: "",
          name_code: "",
          taken_dates_array: [],
          taken_full_partial_array: [],
          taken_info_array: [],
          taken_status_array: [],
          taken_ids: [],
        },
        sick: {
          name: "",
          name_plural: "",
          name_code: "",
          taken_dates_array: [],
          taken_full_partial_array: [],
          taken_info_array: [],
          taken_status_array: [],
          taken_ids: [],
        },
        holiday: {
          name: "",
          name_plural: "",
          name_code: "",
          taken_dates_array: [],
          taken_full_partial_array: [],
          taken_info_array: [],
          taken_status_array: [],
          taken_ids: [],
        },
        personal: {
          name: "",
          name_plural: "",
          name_code: "",
          taken_dates_array: [],
          taken_full_partial_array: [],
          taken_info_array: [],
          taken_status_array: [],
          taken_ids: [],
        },
        bereavement: {
          name: "",
          name_plural: "",
          name_code: "",
          taken_dates_array: [],
          taken_full_partial_array: [],
          taken_info_array: [],
          taken_status_array: [],
          taken_ids: [],
        },
        jury_duty: {
          name: "",
          name_plural: "",
          name_code: "",
          taken_dates_array: [],
          taken_full_partial_array: [],
          taken_info_array: [],
          taken_status_array: [],
          taken_ids: [],
        },
        covid: {
          name: "",
          name_plural: "",
          name_code: "",
          taken_dates_array: [],
          taken_full_partial_array: [],
          taken_info_array: [],
          taken_status_array: [],
          taken_ids: [],
        },
        covid_sick: {
          name: "",
          name_plural: "",
          name_code: "",
          taken_dates_array: [],
          taken_full_partial_array: [],
          taken_info_array: [],
          taken_status_array: [],
          taken_ids: [],
        },

      },

      //  pto_types: pto_func.getPtoCats("object"),

      commentRules: {
        required: (v) => !!v || "Incorrect Reason field cannot be blank",
        counter: (v) => v.length <= 200 || "Max 200 characters",
      },

      //months: [ "January", "February", "March", "April", "May", "June", 
      //     "July", "August", "September", "October", "November", "December" ],
      months: {
          1: "January",
          2: "February",
          3: "March",
          4: "April",
          5:  "May",
          6: "June",
          7: "July",
          8: "August",
          9: "September",
          10: "October",
          11: "November",
          12: "December",
      }
           

    };
  },

  async created() {

    this.pto_cat_names = pto_func.getPtoCats("names");
    this.pto_cat_plurals = pto_func.getPtoCats("plurals");
    //this.pto_cat_codes = pto_func.getPtoCats("codes");
    this.pto_cat_codes = pto_func.getPtoCats("pto_mgr_appr_codes");

    let tmp_pto_format = pto_func.pto_set_format();
    let tmp_pto_data = null;
    let fy = this.cur_fiscal_year;

    // Before data roll, only confirm prev year pto
    if (this.site_status == "prev_and_cur_year")
      fy = this.prev_fiscal_year;

    const response = await axios.get("./remote-apis/pto_api.php?cmd=pto_emp&year="+fy);
    tmp_pto_data = pto_func.fy_formatEmpPto(response.data, tmp_pto_format, this.pto_cat_codes, this.pto_cat_names, this.pto_cat_plurals, fy);
    tmp_pto_data['firstname'] = tmp_pto_data[fy]['firstname'];
    tmp_pto_data['lastname'] = tmp_pto_data[fy]['lastname'];
    this.cfm_pto = tmp_pto_data[fy]; 

    var tmp_cat = "";
    var counter = 0;

    for (var i = 0; i < this.pto_cat_codes.length; i++) {
      tmp_cat = this.pto_cat_codes[i];
      counter = 0;

      if (
        this.cfm_pto[tmp_cat]["taken_dates_array"] &&
        this.cfm_pto[tmp_cat]["taken_dates_array"].length > 0
      ) {
        for (
          var t = 0;
          t < this.cfm_pto[tmp_cat]["taken_dates_array"].length;
          t++
        ) {


          if (
            this.cfm_pto[tmp_cat]["taken_status_array"][t] != "Confirmed" 
          ) {
            if (counter <= 0) {
              this.p_cfm_pto[tmp_cat]["name"] = this.cfm_pto[tmp_cat]["name"];
              this.p_cfm_pto[tmp_cat]["name_plural"] =
                this.cfm_pto[tmp_cat]["name_plural"];
              this.p_cfm_pto[tmp_cat]["name_code"] =
                this.cfm_pto[tmp_cat]["name_code"];
            }

            this.p_cfm_pto[tmp_cat]["taken_dates_array"].push(
              this.cfm_pto[tmp_cat]["taken_dates_array"][t]
            );
            this.p_cfm_pto[tmp_cat]["taken_full_partial_array"].push(
              this.cfm_pto[tmp_cat]["taken_full_partial_array"][t]
            );
            this.p_cfm_pto[tmp_cat]["taken_info_array"].push(
              this.cfm_pto[tmp_cat]["taken_info_array"][t]
            );
            this.p_cfm_pto[tmp_cat]["taken_status_array"].push(
              this.cfm_pto[tmp_cat]["taken_status_array"][t]
            );
            this.p_cfm_pto[tmp_cat]["taken_ids"].push(
              tmp_cat +
                "_" +
                this.cfm_pto[tmp_cat]["taken_dates_array"][t] +
                "_" +
                this.cfm_pto[tmp_cat]["taken_full_partial_array"][t]
            );
            counter++;
          }
        }
      }

      this.toggle_exclusive[i] = [];

      for (var a = 0; a < this.p_cfm_pto[tmp_cat]["taken_ids"].length; a++) {
        this.toggle_states.push({
          taken_id: this.p_cfm_pto[tmp_cat]["taken_ids"][a],
          value: "",
        });

        this.toggle_exclusive[i][a] = 0;
        this.inputs.push({
          taken_id: this.p_cfm_pto[tmp_cat]["taken_ids"][a],
          comment: "",
          cfm_type: "",
        });
      }

      if (this.inputs.length > 0) {
        this.has_pending_pto = true;
      }

    }

  /*
    axios.get("./remote-apis/pto_api.php?cmd=pto_pc").then((response) => {
      let pto_pc = response.data;
      if (pto_pc.response == 0) {
        let saas_no_pto_mth = pto_pc.pending_months;
        if (saas_no_pto_mth) {
          let saas_p_array = saas_no_pto_mth.split("|");
          for (let x = 0; x < saas_p_array.length; x++) {
            this.no_pto_inputs.push({
              month_num: saas_p_array[x],
              month_name: this.months[saas_p_array[x]],
              id: "month_" + saas_p_array[x],
              cfm_type: "",
              comment: ""
            });
          }
          this.has_no_pto_mth = true;
        }
      } 
    }); 
  */

    let saas_no_pto_mth = this.ptoInfo.ptopc_pending_months;
    if (saas_no_pto_mth) {
      let saas_p_array = saas_no_pto_mth.split("|");
      for (let x = 0; x < saas_p_array.length; x++) {
        this.no_pto_inputs.push({
          month_num: saas_p_array[x],
          month_name: this.months[saas_p_array[x]],
          id: "month_" + saas_p_array[x],
          cfm_type: "",
          comment: ""
        });
      }
      this.has_no_pto_mth = true;
    }

  },

 
  methods: {

    closeDialog(clicked) {
      this.dialog2 = false;
      if (clicked == "leave") {
        window.location.reload();
      } else if (clicked == "success") {
        window.location.reload();
      }
    },

    selectNoPto(e) {
      var id = e.currentTarget.getAttribute("id");
      var action = e.currentTarget.value;
      var element = document.getElementById(id);
      var data = e.currentTarget.getAttribute("data");
      var yes_el = document.getElementById(data + "_yes");
      var no_el = document.getElementById(data + "_no");
      var isActive = element.classList.contains("pto_btn_active");
      var cfm_type = "";

      // css stuff
      yes_el.classList.remove("pto_btn_active");
      no_el.classList.remove("pto_btn_active");

      if (
        action == "no" &&
        document.getElementById(data).style.display == "none"
      ) {
        // Show input fields.
        document.getElementById(data).style.display = "";
        element.classList.add("pto_btn_active");
        cfm_type = "no";
      } else {
        // yes or click yes/no again
        // reset input fields
        for (var i = 0; i < this.no_pto_inputs.length; i++) {
          // Reset input fields
          if (this.no_pto_inputs[i]["id"] == data) {
            this.no_pto_inputs[i]["comment"] = "";
            this.no_pto_inputs[i]["cfm_type"] = "";
            break;
          }
        }

        if (action == "yes" && !isActive) {
          element.classList.add("pto_btn_active");
          cfm_type = "yes";
        }

        // hide input fields
        document.getElementById(data).style.display = "none";
      }

      for (var j = 0; j < this.no_pto_inputs.length; j++) {
          if (this.no_pto_inputs[j]["id"] == data) {
            this.no_pto_inputs[j]["cfm_type"] = cfm_type;
            break;
          }
      } 
    },

    selectPtoCfm(e) {
      var id = e.currentTarget.getAttribute("id");
      var action = e.currentTarget.value;
      var element = document.getElementById(id);
      var data = e.currentTarget.getAttribute("data");
      var yes_el = document.getElementById(data + "_yes");
      var no_el = document.getElementById(data + "_no");
      var isActive = element.classList.contains("pto_btn_active");
      var cfm_type = "";

      // css stuff
      yes_el.classList.remove("pto_btn_active");
      no_el.classList.remove("pto_btn_active");

      if (
        action == "no" &&
        document.getElementById(data).style.display == "none"
      ) {
        // Show input fields.
        document.getElementById(data).style.display = "";
        element.classList.add("pto_btn_active");
        cfm_type = "no";
      } else {
        // yes or click yes/no again
        // reset input fields
        for (var i = 0; i < this.inputs.length; i++) {
          // Reset input fields
          if (this.inputs[i]["taken_id"] == data) {
            this.inputs[i]["comment"] = "";
            this.inputs[i]["cfm_type"] = "";
            break;
          }
        }

        if (action == "yes" && !isActive) {
          element.classList.add("pto_btn_active");
          cfm_type = "yes";
        }

        // hide input fields
        document.getElementById(data).style.display = "none";
      }

      for (var j = 0; j < this.inputs.length; j++) {
          if (this.inputs[j]["taken_id"] == data) {
            this.inputs[j]["cfm_type"] = cfm_type;
            break;
          }
      }
    },

    submitPtoConfirm() {
      
      var hasChanges = this.hasChanges();
      
      if (!hasChanges) {
        this.dialog2_title = "Are you sure?";
        this.dialog2_text =
          "You did not make any changes. Do you want to leave this page?";
        this.dialog2_redBtn = "Leave";
        this.dialog2_redBtn_type = "leave";
        this.dialog2_blueBtn = "Cancel";
        this.dialog2_blueBtn_type = "cancel";
        this.dialog2 = true;
        return;
      }

      if (this.validateChanges() == false) {
        return;
      }

      // First, confirm no dates taken.
      if (this.has_no_pto_mth == true) {
        axios
         .post("./remote-apis/ptoApprove.php", {
          formData: JSON.stringify(this.no_pto_inputs),
          action: JSON.stringify("no_pto_confirm"),
        })
        .then((res) => {
          if (res.data.response == "OK") {
            if (this.has_pending_pto == false) {
              this.dialog2_title = "Thank you!";
              this.dialog2_text = "Data saved.";
              this.dialog2_blueBtn_type = "success";
              this.dialog2 = true;
            }
          } else {
            var message =
              "Data cannot be saved. Please try again later.";
            if (res.data.message) message = res.data.message;
            this.dialog2_blueBtn_type = "error";
            this.dialog2_text = message;
            this.dialog2 = true;
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
      } 

      // Confirm pto requests.
      if (this.has_pending_pto) {
        axios
          .post("./remote-apis/ptoApprove.php", {
          formData: JSON.stringify(this.inputs),
          action: JSON.stringify("confirm"),
        })
        .then((res) => {
          if (res.data.response == "OK") {
            this.dialog2_title = "Thank you!";
            this.dialog2_text = "Data saved.";
            this.dialog2_blueBtn_type = "success";
            this.dialog2 = true;
          } else {
            var message =
              "Data cannot be saved. Please try again later.";
            if (res.data.message) message = res.data.message;
            this.dialog2_blueBtn_type = "error";
            this.dialog2_text = message;
            this.dialog2 = true;
          }
        })
        .catch((error) => {
          window.console.log(error);
        }); 
      }
    },

    validateChanges() {

      var yes_id = null;
      var no_id = null;
      var err_msg = "";

      for (var a = 0; a < this.no_pto_inputs.length; a++) {
        yes_id = document.getElementById(this.no_pto_inputs[a]["id"] + "_yes");
        no_id = document.getElementById(this.no_pto_inputs[a]["id"] + "_no");
        if (yes_id.classList.contains("pto_btn_active") == false  &&
            no_id.classList.contains("pto_btn_active") == false) {
              err_msg = "Please confirm all PTO.";
              break;
        }
        if (no_id.classList.contains("pto_btn_active") && this.no_pto_inputs[a]["comment"].trim().length <= 0) {
            err_msg = "Please provide incorrect reason.";
            break;
        }
      }       

      if (err_msg.length <= 0) {
        for (var i = 0; i < this.inputs.length; i++) {
          yes_id = document.getElementById(this.inputs[i]["taken_id"] + "_yes");
          no_id = document.getElementById(this.inputs[i]["taken_id"] + "_no");
          if (yes_id.classList.contains("pto_btn_active") == false  &&
            no_id.classList.contains("pto_btn_active") == false) {
              err_msg = "Please confirm all date(s).";
              break;
          }
          if (no_id.classList.contains("pto_btn_active") && this.inputs[i]["comment"].trim().length <= 0) {
            err_msg = "Please provide incorrect reason for not confirm date(s).";
            break;
          }
        }      
    }

      if (err_msg.length > 0) {
        this.dialog2_title = "Alert!";
        this.dialog2_text = err_msg;
        this.dialog2_blueBtn = "OK";
        this.dialog2_blueBtn_type = "cancel";
        this.dialog2 = true;
        return false;
      }

      return true;
    },

    closeConfirmDialog() {
      var showConfirm = false;
      if (this.hasChanges())
        showConfirm = true;

      if (showConfirm) {
        (this.dialog2_title = "You have unsaved changes"),
          (this.dialog2_text =
            "You are about to leave this page without saving. All changes will be lost. Do you want to leave without saving?");
        this.dialog2_redBtn = "Leave";
        this.dialog2_redBtn_type = "leave";
        this.dialog2_blueBtn = "Cancel";
        this.dialog2_blueBtn_type = "cancel";
        this.dialog2 = true;
        return false;
      } else {
        this.dialog = false;
        window.location.reload();
      }
    },

    hasChanges() {

      var yes_id = null;
      var no_id = null;

      for (var a = 0; a < this.no_pto_inputs.length; a++) {
        if (this.no_pto_inputs[a]["comment"].trim().length > 0) {
          return true;
        } else {
          yes_id = document.getElementById(this.no_pto_inputs[a]["id"] + "_yes");
          no_id = document.getElementById(this.no_pto_inputs[a]["id"] + "_no");
          if (
            yes_id.classList.contains("pto_btn_active") ||
            no_id.classList.contains("pto_btn_active")
          ) {
            return true;
          }
        }
      } 

      yes_id = null;
      no_id = null;

      for (var i = 0; i < this.inputs.length; i++) {
        if (this.inputs[i]["comment"].trim().length > 0) {
          return true;
        } else {
          yes_id = document.getElementById(this.inputs[i]["taken_id"] + "_yes");
          no_id = document.getElementById(this.inputs[i]["taken_id"] + "_no");
          if (
            yes_id.classList.contains("pto_btn_active") ||
            no_id.classList.contains("pto_btn_active")
          ) {
            return true;
          }
        }
      }      
      return false;

    },

  },
};
</script>

<style scoped>
.ptoBtn:focus::before {
  opacity: 0 !important;
}

.list-item-date {
  padding-right: 80px;
}

.prompt {
  font-weight: 500;
}

.dateBlockMobile {
  width: 98%;
  margin-left: 15px;
}

.dateBlock {
  width: 75%;
  margin-left: 80px;
}

.v-subheader {
  font-size: 16px;
  color: #000;
}

.v-list-item {
  min-height: 50px;
}

.v-list-item__content {
  padding-top: 0px !important;
}

.ptoClose .v-btn__content .v-icon {
  color: #fff !important;
}

.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 32px;
  min-width: 100px;
}

.dk_brown {
  background-color: #4f2c1d;
}

.row {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.v-label,
span.label {
  font-weight: normal !important;
}

.icon-circle-gray {
  background: #bbb;
  padding: 2px;
  border-radius: 50%;
}

.icon-circle-green {
  color: green;
}

.icon-white {
  color: #fff;
  font-size: 1.1em;
}

.custom1cols {
  width: 100%;
  max-width: 100%;
  flex-basis: 100%;
  padding-left: 0px;
  padding-bottom: 0px;
}

.confirmCustom1cols {
  width: 90%;
  max-width: 90%;
  flex-basis: 90%;
  padding-left: 0px;
  padding-bottom: 0px;
}

.custom3cols {
  width: 25%;
  max-width: 25%;
  flex-basis: 25%;
  padding-left: 5px;
  padding-bottom: 0px;
}

.custom4cols {
  width: 75%;
  max-width: 75%;
  flex-basis: 75%;
  padding-bottom: 0px;
}

.radio {
  display: inline-block;
}

.radio /deep/ label {
  font-weight: normal !important;
}

.v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 0px !important;
}

.custom9cols {
  width: 75%;
  max-width: 75%;
  flex-basis: 75%;
  padding-bottom: 0px;
}

.pto_btn_active {
  background-color: #7a6855 !important;
  color: #ffffff;
}

.pto_align_center {
  padding-top: 28px !important;
}

.v-application p.inst {
  margin-top: 1px;
  font-style: italic;
  font-size: 13px;
  width: 90%;
  padding-bottom: 0;
  margin-bottom: 0;
}

.note {
  margin: 4px;
  font-style: italic;
  font-size: 13px;
  width: 90%;
}

.inst a {
  text-decoration-color: #ffb500 !important;
  text-decoration-thickness: 2px !important;
  text-decoration: underline;
}

.v-application .blue {
  background-color: #2196f3 !important;
  border-color: #2196f3 !important;
  color: #ffffff !important;
}

.form_padding {
  padding-top: 25px;
  padding-bottom: 25px;
}

.container {
  width: 92% !important;
}

</style>